import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner, Pagination, Dropdown } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../../utilities/url";
import authService from "../../../services/auth.service";
import storage from "../../../services/storage";
import CryptoJS from "crypto-js";
import { MdFileUpload, MdFilterList, MdSearch } from "react-icons/md";
import { PiListBold } from "react-icons/pi";
import { RxDashboard } from "react-icons/rx";
import { IoMdCloseCircle } from "react-icons/io";
import CardList from "./cardList";
import TableList from "./tableList";

const FileModal = ({ show, handleFunctionS, onClose }) => {
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [loading, setLoading] = useState(false);
  const [listView, setListView] = useState("card");
  const [fileData, setFileData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [totalItems, setTotalItem] = useState(0);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(null);
  const itemPerPages = 8;
  const [searchValue, setSearchValue] = useState(null);
  const optionSort = [
    {
      value: "a-asc",
      label: "Alphabetical A-Z",
    },
    {
      value: "a-desc",
      label: "Alphabetical Z-A",
    },
    {
      value: "l-desc",
      label: "Last Uploaded",
    },
  ];
  const [selectedSorting, setSelectedSorting] = useState(() => {
    const sorted = storage.get("sortedData");
    return sorted ? sorted : optionSort[2];
  });

  const handleSorting = (data) => {
    setSelectedSorting(data);
    storage.setUnlimited("sortedData", data);
  };

  const handleListView = (view) => setListView(view);
  const handlePageChange = (page) => setCurrentPage(page);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearch || debouncedSearch === "") {
      fetchFileData();
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (show) {
      fetchFileData();
    }
  }, [show, currentPage, selectedSorting]);

  const fetchFileData = async () => {
    try {
      setLoading(true);
      axios
        .post(
          API_URL + "get-media-storage",
          {
            idt_workspace: workspace.idt_user_workspace,
            name: searchValue,
            sort: selectedSorting.value,
            page: currentPage,
            limit: itemPerPages,
          },
          {
            headers: {
              Authorization: `Bearer ${storage.get("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success === true) {
            setFileData(res.data.data.data);
            setTotalItem(res.data.data.meta.total_items);
            setTotalPages(res.data.data.meta.total_pages);
            setTotalFileSize(res.data.data.meta.total_filesize);
          }
        })
        .catch((error) => {
          if (error.response.data.message) {
            authService.logout();
          }
        });
    } catch (error) {
      console.error("Gagal memuat data file:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeData = (data) => {
    handleFunctionS(data);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add-Ons File</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}
      >
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p className="mt-2">Memuat data...</p>
          </div>
        ) : (
          <>
            {fileData ? (
              <>
                <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                  {/* View switch */}
                  <nav className="nav btn-group rounded-pill me-2">
                    <button
                      className={`btn btn-outline-dark ${
                        listView === "card" ? "active" : ""
                      }`}
                      onClick={() => handleListView("card")}
                    >
                      <RxDashboard />
                    </button>
                    <button
                      className={`btn btn-outline-dark ${
                        listView === "table" ? "active" : ""
                      }`}
                      onClick={() => handleListView("table")}
                    >
                      <PiListBold />
                    </button>
                  </nav>

                  {/* Filter dropdown */}
                  <Dropdown align="end" flip={false}>
                    <Dropdown.Toggle
                      variant="light"
                      className="d-flex align-items-center"
                    >
                      <MdFilterList size={17} className="me-2" />
                      {selectedSorting.label}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ marginTop: "40px" }}>
                      {optionSort.map((option) => (
                        <Dropdown.Item
                          key={option.value}
                          onClick={() => handleSorting(option)}
                        >
                          {option.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* Search input */}
                  <div className="app-search position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      style={{ width: "200px" }}
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <span className="search-widget-icon cursor-pointer">
                      <MdSearch size={18} />
                    </span>
                    {searchValue && (
                      <span
                        onClick={() => setSearchValue("")}
                        className="search-widget-icon search-widget-icon-close cursor-pointer"
                      >
                        <IoMdCloseCircle size={18} />
                      </span>
                    )}
                  </div>
                </div>

                <hr />

                <div>
                  {listView === "card" ? (
                    <CardList
                      cards={fileData}
                      loading={loading}
                      onChangeData={handleChangeData}
                    />
                  ) : (
                    <TableList
                      cards={fileData}
                      loading={loading}
                      onChangeData={handleChangeData}
                    />
                  )}
                </div>

                {totalItems > itemPerPages && totalPages > 1 && (
                  <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                )}
              </>
            ) : (
              <p>Data tidak tersedia</p>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FileModal;
